import { BaseModel } from './base.model';

export class ChecklistEndpointModel extends BaseModel {
    type_id?: string;
    endpoint_name?: string;

    external_api: string;
    external_token?: string;
    additional_params?: string;

    checklist_id: number;

    constructor(model?: ChecklistEndpointModel) {
        super();

        this.type_id = model ? model.type_id || null : null;
        this.endpoint_name = model ? model.endpoint_name || null : null;

        this.external_api = model ? model.external_api || null : null;
        this.external_token = model ? model.external_token || null : null;
        this.additional_params = model ? model.additional_params || null : null;

        this.checklist_id = model ? model.checklist_id || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/checklist-endpoint.model.ts